import { useState, useEffect, useContext } from 'react'
import Cookies from 'js-cookie'

import CharsheetMobile from '../components/CharsheetMobile/CharsheetMobile.js'
import CharsheetDM from '../components/CharsheetDM/CharsheetDM.js'
import RollDice from '../components/RollDice'
import Spellbook from '../components/Spellbook.js'
import CharNameMobile from '../components/CharNameMobile.js'

import { BLANK_CHARACTER } from 'constants/characters.js'
import sample_data_flat from '../components/Charsheet0/helpers/sample_data_flat.js'
import LOAD_CHAR from '../components/Charsheet0/helpers/load_char2.js'
import unflatten from '../components/Charsheet0/helpers/unflatten.js'
import flatten from '../components/Charsheet0/helpers/flatten.js'

import { UserDataContext } from "../App.js";
import Charsheet from 'components/Charsheet0/Charsheet0.js'

// This page exists between MobileHome and CharsheetMobile
//   it's purpose is to own the character data

function MobileDataPage(props) {

  console.log('Mobile Data props ', props )

    // ------ inherited state variables ------

    const [userData, setUserData] = useContext(UserDataContext);

    const layout = props.state[3];

    // ------ local state variables ------ 

  // character data
  const c0start = (localStorage.getItem('char0data' ) ? localStorage.getItem('char0data') : sample_data_flat )
  const [ char0data, setChar0Data ] = useState( c0start ); // use char0data from local storage if it is there

  let testCharacter = flatten({'chardata': BLANK_CHARACTER });
  testCharacter.name = "Load Character"
  testCharacter.myStr = "18/00";
  const [ chardata1, setCharData1 ] = useState( testCharacter );
  const [ chardata2, setCharData2 ] = useState( testCharacter );
  const [ chardata3, setCharData3 ] = useState( testCharacter );
  const [ chardata4, setCharData4 ] = useState( testCharacter );
  const [ chardata5, setCharData5 ] = useState( testCharacter );
  const [ chardata6, setCharData6 ] = useState( testCharacter );
  const [ chardata7, setCharData7 ] = useState( testCharacter );
  const [ chardata8, setCharData8 ] = useState( testCharacter );

  console.log(testCharacter)
  console.log(c0start)
  
  const tempCharDataArray = useState(sample_data_flat);

  const currentChar = props.state[0];
  const setChar = props.state[1];
  const numChars = props.numCharsArray ? props.numCharsArray[0] : 1;

    // v0.5 spell checks
    const emptyChecks = ['Empty','Empty','Empty','Empty','Empty','Empty']
    const initialSpellChecks = Array.from({ length: 270 }, () => [...emptyChecks]);

    // Create 10 independent useState calls
    const [spellChecks0, setSpellChecks0] = useState(initialSpellChecks);
    const [spellChecks1, setSpellChecks1] = useState(initialSpellChecks);
    const [spellChecks2, setSpellChecks2] = useState(initialSpellChecks);
    const [spellChecks3, setSpellChecks3] = useState(initialSpellChecks);
    const [spellChecks4, setSpellChecks4] = useState(initialSpellChecks);
    const [spellChecks5, setSpellChecks5] = useState(initialSpellChecks);
    const [spellChecks6, setSpellChecks6] = useState(initialSpellChecks);
    const [spellChecks7, setSpellChecks7] = useState(initialSpellChecks);
    const [spellChecks8, setSpellChecks8] = useState(initialSpellChecks);
    const [spellChecks9, setSpellChecks9] = useState(initialSpellChecks);

    // Derive megaSpellCheckArray
    const megaSpellCheckArray = [
      spellChecks0.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks0((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks1.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks1((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks2.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks2((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks3.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks3((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks4.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks4((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks5.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks5((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks6.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks6((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks7.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks7((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks8.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks8((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
      spellChecks9.map((check, index) => [
        check,
        (newValue) =>
          setSpellChecks9((prev) => {
            const newChecks = [...prev];
            newChecks[index] = newValue;
            return newChecks;
          }),
      ]),
    ];


  useEffect( () => {

    async function DoSomething () {

      const result = await LOAD_CHAR( currentChar, setChar, false, userData, 'Charsheet Mobile Data Page' );

      const flatCharData = flatten(result.data)
      setChar0Data( flatCharData );
      tempCharDataArray[1]( flatCharData );

      // v0.5 set spell check data
      for (let i=1; i<=9; i++) {
        for (let j=1; j<=30; j++) {
          const idx = (i-1)*30 + (j-1)
          const spellCheckVarName = "mySpk" + String(i) + String(j).padStart(2, '0')

          // the second item in the Array is the update function
          let updateSpellCheck = megaSpellCheckArray[0][idx][1]
          
          const spellChecksThis = flatCharData[spellCheckVarName]
          
          // set the data if it exists
          if (typeof spellChecksThis !== 'undefined') {
            updateSpellCheck( spellChecksThis )

          } else {
          // set to Empty if no data
            
            updateSpellCheck(['Empty','Empty','Empty','Empty','Empty','Empty'])
          }
        }   
      }
    }

    DoSomething();

    }, [ currentChar, setChar ]) ;


    useEffect ( () => {
    console.log(`Layout: ${layout}`)
    }, [ layout ]) ;


    useEffect( () => {
        // const { chardata, ...dataToStore } = char0data;
        let dataToStore = { };
        dataToStore.name = char0data.name;
        dataToStore.campaign =Cookies.get('currentCampaign');
        dataToStore.chardata = unflatten(char0data);
        localStorage.setItem('char0data', JSON.stringify(dataToStore));
        
    },[char0data]); //useEffect

  return (
    <> 
      <div id="mobile-main" style={{ }}>

      { layout === 'mobile-DM' ? 
        <CharsheetDM state={ props.state } charID='charMobile' data={ char0data } setdata={ setChar0Data } spellCheckArray={megaSpellCheckArray[0]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/>
      :
      <>
        <CharsheetMobile state={ props.state } charID='charMobile' data={ char0data } setdata={ setChar0Data } spellCheckArray={megaSpellCheckArray[0]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/>
         
        { numChars >= 2 && <CharsheetMobile state={ props.state } charID='charMobile1' data={ chardata1 } setdata={ setCharData1 } spellCheckArray={megaSpellCheckArray[1]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/> }
        { numChars >= 3 && <CharsheetMobile state={ props.state } charID='charMobile2' data={ chardata2 } setdata={ setCharData2 } spellCheckArray={megaSpellCheckArray[2]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/> }
        { numChars >= 4 && <CharsheetMobile state={ props.state } charID='charMobile3' data={ chardata3 } setdata={ setCharData3 } spellCheckArray={megaSpellCheckArray[3]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/> }
        { numChars >= 5 && <CharsheetMobile state={ props.state } charID='charMobile4' data={ chardata4 } setdata={ setCharData4 } spellCheckArray={megaSpellCheckArray[4]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/> }
        { numChars >= 6 && <CharsheetMobile state={ props.state } charID='charMobile5' data={ chardata5 } setdata={ setCharData5 } spellCheckArray={megaSpellCheckArray[5]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/> }
        { numChars >= 7 && <CharsheetMobile state={ props.state } charID='charMobile6' data={ chardata6 } setdata={ setCharData6 } spellCheckArray={megaSpellCheckArray[6]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/> }
        { numChars >= 8 && <CharsheetMobile state={ props.state } charID='charMobile7' data={ chardata7 } setdata={ setCharData7 } spellCheckArray={megaSpellCheckArray[7]} tempCharDataArray={tempCharDataArray} activeViewArray={props.activeViewArray}/> }
        </>
      } 

      <RollDice IDadd="mobile"/>
      
      </div>
      { layout !== 'mobile-DM' ?
      <Spellbook chardata={char0data} globalState={props.state} />
      : null
      }

    
    </>
  )
}

export default MobileDataPage; 
